import { Box, Button, Container, Flex } from '@everlywell/ui-kit';
import { SectionHeader } from 'components/SectionHeader';
import React from 'react';

interface IFullBackgroundSection {
  sectionImage?: {
    url: string;
  };
  headline?: string;
  description?: {
    description: string;
  };
  cta?: {
    appearance?: 'primary' | 'secondary';
    url: string;
    label: string;
  };
}

const FullBackgroundSection: React.FC<IFullBackgroundSection> = ({
  sectionImage,
  headline,
  description,
  cta,
}) => (
  <Box
    as="section"
    py={['4rem', '6rem', '8rem']}
    overflow="hidden"
    backgroundImage={`url(${sectionImage?.url})`}
    backgroundSize="cover"
    backgroundPosition="center"
    position="relative"
  >
    <Container maxWidth="1440px" mx="auto" px={['1rem', '2rem']}>
      <Flex direction="column" alignItems="center" gap="2rem">
        <SectionHeader
          title={headline || ''}
          titleMaxWidth="900px"
          descriptionMaxWidth="550px"
          description={description?.description}
          align="center"
        />

        <Button
          as="a"
          href={cta?.url || '#'}
          target="_self"
          aria-label={cta?.label || 'Learn more'}
          height="3.25rem"
          px="2rem"
          bg={cta?.appearance === 'primary' ? '#012B3B' : 'white'}
          color={cta?.appearance === 'primary' ? 'white' : '#012B3B'}
          fontSize="16px"
          fontWeight="500"
          _hover={{
            bg: cta?.appearance === 'primary' ? '#012B3B' : 'white',
            color: cta?.appearance === 'primary' ? 'white' : '#012B3B',
          }}
        >
          {cta?.label || 'Learn more'}
        </Button>
      </Flex>
    </Container>
  </Box>
);

export default FullBackgroundSection;
